// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AddEtreprise,Login } from '../../../../core/auth';
import { AuthService } from '../../../../core/auth/_services/auth.service';
import * as firebase from 'firebase';

/**
 * ! Just example => Should be removed in development
 */
const DEMO_PARAMS = {
	username: '',
	PASSWORD: ''
};

@Component({
	selector: 'kt-add-entreprise',
	templateUrl: './add-entreprise.component.html',
	encapsulation: ViewEncapsulation.None
})
export class AddEntrepriseComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];

	private unsubscribe: Subject<any>;

	private returnUrl: any;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		public authservice: AuthService,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.initLoginForm();

		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params['returnUrl'] || '/';
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `Use account
			<strong>${DEMO_PARAMS.username}</strong> and password
			<strong>${DEMO_PARAMS.PASSWORD}</strong> to continue.`;
			this.authNoticeService.setNotice(initialNotice, 'info');
		}

		this.loginForm = this.fb.group({
			username: [DEMO_PARAMS.username, Validators.compose([
				Validators.required,
			 Validators.pattern('^[a-z]+$'),
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			],
			// password: [DEMO_PARAMS.PASSWORD, Validators.compose([
			// 	Validators.required,
			// 	Validators.minLength(3),
			// 	Validators.maxLength(100)
			// ])
			// ]
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		this.loading = true;
		this.authservice.AddNameSpace(this.loginForm.value.username,null).subscribe(
			data => {
				firebase.auth().signInWithCustomToken(data).then((data) => {
					this.store.dispatch(new Login({authToken:this.authservice.getToknen(1)}));					
					this.loading = false;
					this.router.navigate(['/']);
				});
			},
			error => {
				this.authNoticeService.setNotice(this.translate.instant('Namespace already exists !'), 'danger');
			}
		);


	}

	/**
	 * Checking control validation
	 *
	 * @param controlusername: string => Equals to formControlusername
	 * @param validationType: string => Equals to valitors username
	 */
	isControlHasError(controlusername: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlusername];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
}
